import { noop } from '../error'

function watchFeature (feature) {
  if (!feature) {
    return
  }

  const watchedFeatures = this.$auth.$state.user.watched_features.slice()

  this.$axios
    .$post('/features/', { feature }, { xhrLoader: false })
    .then(() => {
      watchedFeatures.push(feature)

      this.$store.commit('auth/SET', {
        key: 'user',
        value: {
          ...this.$auth.user,
          watched_features: watchedFeatures
        }
      })
    })
    .catch(noop)
}

export {
  watchFeature as default
}
